import React from 'react'

const Feetable = ({ studentData,
    feeStructures,
    selectedFSData,
    months,
    forConcession,
    setForConcession,
    rowConcessions,
    setRowConcessions,
    editableMonths,
    setEditableMonths,
    updatedFSData,
    handleRowConcessionApply,
    heads,
    MONTHLY_FEE_KEY,
    routeMonthlyFees,
concessionAllowed,
  concessionMessage, }) => {
    // if (!studentData.feeStructureId || !selectedFSData) return null;
    return (
        <div className="p-6">
            {/* Only show table if a fee structure is selected */}
            {studentData.feeStructureId && selectedFSData && (
                <>
                    {/* Regular Fee Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border px-4 py-2 text-left text-sm font-semibold">ID</th>
                                    <th className="border px-4 py-2 text-left text-sm font-semibold">Fee Head</th>
                                    {months.map((m) => (
                                        <th key={m} className="border px-4 py-2 text-center text-sm font-semibold">{m}</th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* ONE-TIME FEES */}
                                {Object.entries(selectedFSData.feeHeadValues
                                )
                                    .filter(([key]) => !key.startsWith("month") && key !== "totalfees")
                                    .map(([feeHead, amount], index) => (
                                        <tr key={feeHead}>
                                            <td className="border px-4 py-2 text-sm">{index + 1}</td>
                                            <td className="border px-4 py-2 text-sm font-medium">{feeHead}</td>

                                            {/* First month only */}
                                            <td className="border px-4 py-2 text-center">{amount}</td>

                                            {/* Remaining months empty */}
                                            {Array.from({ length: 11 }).map((_, i) => (
                                                <td key={i} className="border px-4 py-2 text-center">—</td>
                                            ))}
                                        </tr>
                                    ))}

                                {/* MONTHLY FEE ROW */}
                                <tr className="bg-blue-50 font-semibold">
                                    <td className="border px-4 py-2">
                                        {Object.entries(selectedFSData.feeHeadValues)
                                            .filter(([key]) => !key.startsWith("month") && key !== "totalfees")
                                            .length + 1}
                                    </td>
                                    <td className="border px-4 py-2">Monthly Fee</td>

                                    {[...Array(12)].map((_, i) => (
                                        <td key={i} className="border px-4 py-2 text-center">
                                            {selectedFSData[`month${i + 1}`]}
                                        </td>
                                    ))}

                                </tr>
                                {routeMonthlyFees && (
                                    <tr className="bg-green-50 font-semibold">
                                        <td className="border px-4 py-2">—</td>
                                        <td className="border px-4 py-2">Route Fee</td>

                                        {[...Array(12)].map((_, i) => (
                                            <td key={i} className="border px-4 py-2 text-center">
                                                {routeMonthlyFees[`month${i + 1}`] ?? 0}
                                            </td>
                                        ))}
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>

                    {/* For Concession Checkbox */}
                    <div className="py-4">
  {!concessionAllowed && concessionMessage && (
    <p className="text-red-600 text-sm font-semibold mb-2">
      {concessionMessage}
    </p>
  )}

  <label
    className={`flex items-center space-x-2 ${
      concessionAllowed ? "cursor-pointer" : "cursor-not-allowed opacity-60"
    }`}
  >
    <input
      type="checkbox"
      checked={forConcession}
      disabled={!concessionAllowed}
      onChange={() => concessionAllowed && setForConcession(prev => !prev)}
      className="w-4 h-4"
    />
    <span className="text-sm font-semibold">For Concession</span>
  </label>
</div>


                    {/* Concession Table */}
                    {forConcession && concessionAllowed && selectedFSData && (
                        <div className="overflow-x-auto">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border px-4 py-2 text-left text-sm font-semibold">ID</th>
                                        <th className="border px-4 py-2 text-left text-sm font-semibold">Fee Head</th>
                                        <th className="border px-4 py-2 text-center text-sm font-semibold">Concession</th>
                                        <th className="border px-4 py-2 text-center text-sm font-semibold">Type</th>
                                        <th className="border px-4 py-2 text-center text-sm font-semibold">Amount</th>
                                        <th className="border px-4 py-2 text-center text-sm font-semibold">Applicable</th>
                                        {months.map(m => (
                                            <th key={m} className="border px-4 py-2 text-center text-sm font-semibold">{m}</th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.entries(selectedFSData?.feeHeadValues)
  .filter(([key]) => !key.startsWith("month") && key !== "totalfees")
  .map(([feeHead, amount], index) => (
    <tr key={feeHead}>
      <td className="border px-4 py-2 text-sm">{index + 1}</td>

      <td className="border px-4 py-2 text-sm font-medium">
        {feeHead}
      </td>

      {/* Concession Column */}
      <td className="border px-4 py-2 text-center text-gray-400">
        —
      </td>

      {/* TYPE (Editable) */}
      <td className="border px-1 py-2">
        <select
          className="border px-2 py-1 w-full"
          value={rowConcessions[feeHead]?.type || "Rs."}
          onChange={(e) =>
            setRowConcessions(prev => ({
              ...prev,
              [feeHead]: {
                ...prev[feeHead],
                type: e.target.value,
                amount: prev[feeHead]?.amount ?? 0
              }
            }))
          }
        >
          <option value="Rs.">Rs.</option>
          <option value="%">%</option>
        </select>
      </td>

      {/* AMOUNT (Editable) */}
      <td className="border px-4 py-2">
        <input
          type="number"
          className="border px-2 py-1 w-20 text-center"
          value={rowConcessions[feeHead]?.amount ?? 0}
          onChange={(e) =>
            setRowConcessions(prev => ({
              ...prev,
              [feeHead]: {
                type: prev[feeHead]?.type || "Rs.", // 🔥 ensure default type always exists
                amount: Number(e.target.value)
              }
            }))
          }
        />
      </td>

      {/* APPLICABLE */}
      <td className="border px-4 py-2 text-center">
        <input
          type="checkbox"
          disabled={!concessionAllowed}
          onChange={(e) =>
            concessionAllowed &&
            handleRowConcessionApply(feeHead, e.target.checked)
          }
        />
      </td>

      {/* First Month Display */}
      <td className="border px-4 py-2 text-center">
        <input
          type="number"
          readOnly
          value={
            editableMonths[feeHead] ??
            updatedFSData?.feeHeadValues?.[feeHead] ??
            selectedFSData.feeHeadValues[feeHead]
          }
          className="border px-2 py-1 w-20 text-center bg-gray-100"
        />
      </td>

      {Array.from({ length: 11 }).map((_, i) => (
        <td key={i} className="border px-4 py-2 text-center">—</td>
      ))}
    </tr>
))}

                                    {/* MONTHLY FEE */}
                                    <tr className="bg-blue-50 font-semibold">
                                        <td className="border px-4 py-2">
                                            {Object.entries(selectedFSData.feeHeadValues)
                                                .filter(([key]) => !key.startsWith("month") && key !== "totalfees")
                                                .length + 1}
                                        </td>

                                        <td className="border px-4 py-2">Monthly Fee</td>

                                        <td className="border px-1 py-2">
                                            <select
  className="border px-2 py-1 w-full"
  value={rowConcessions[MONTHLY_FEE_KEY]?.concessionId ?? ""}
  onChange={(e) => {
    const selected = heads.find(h => h._id === e.target.value);
    if (!selected) return;

    setRowConcessions(prev => ({
      ...prev,
      [MONTHLY_FEE_KEY]: {
        ...prev[MONTHLY_FEE_KEY],
        concessionId: selected._id,
        concessionName: selected.headName,
        // 🔑 NORMALIZATION (THIS WAS MISSING)
        type: selected.discountType === "percentage" ? "%" : "Rs.",
        amount:
          selected.discountType === "percentage"
            ? Number(selected.discount)
            : Number(selected.discountAmount)
      }
    }));
  }}
>
  <option value="">Select</option>
  {heads.map(h => (
    <option key={h._id} value={h._id}>
      {h.headName}
    </option>
  ))}
</select>


                                        </td>

                                        {/* TYPE */}
                                        <td className="border px-1 py-2">
  <select
    className="border px-2 py-1 w-full bg-gray-100 cursor-not-allowed"
    value={rowConcessions[MONTHLY_FEE_KEY]?.type ?? ""}
    disabled
  >
    <option value="Rs.">Rs.</option>
    <option value="%">%</option>
  </select>
</td>



                                        {/* AMOUNT */}
                                       <td className="border px-4 py-2">
  <input
    type="number"
    readOnly
    className="border px-2 py-1 w-20 text-center bg-gray-100 cursor-not-allowed"
    value={rowConcessions[MONTHLY_FEE_KEY]?.amount ?? 0}
  />
</td>




                                        {/* APPLY */}
                                        <td className="border px-4 py-2 text-center">
                                            <input type="checkbox" disabled={!concessionAllowed} onChange={(e) => concessionAllowed && handleRowConcessionApply(MONTHLY_FEE_KEY, e.target.checked)} />


                                        </td>

                                        {/* MONTHS (BACKEND VALUES) */}
                                        {[...Array(12)].map((_, i) => (
                                            <td key={i} className="border px-4 py-2 text-center">
                                                <input
                                                    type="number"
                                                    value={
                                                        editableMonths[`month${i + 1}`] ??
                                                        updatedFSData?.[`month${i + 1}`] ??
                                                        selectedFSData?.[`month${i + 1}`] ??
                                                        0
                                                    }
                                                    onChange={(e) =>
                                                        setEditableMonths(prev => ({
                                                            ...prev,
                                                            [`month${i + 1}`]: Number(e.target.value),
                                                        }))
                                                    }
                                                    className="border px-2 py-1 w-20 text-center"
                                                />



                                            </td>
                                        ))}
                                    </tr>
                                    {routeMonthlyFees && (
                                        <tr className="bg-green-100 font-semibold">
                                            <td className="border px-4 py-2">—</td>
                                            <td className="border px-4 py-2">Route Fee</td>

                                            <td colSpan={4} className="border px-4 py-2 text-center text-gray-500">
                                                Concession Not Allowed
                                            </td>

                                            {[...Array(12)].map((_, i) => (
                                                <td key={i} className="border px-4 py-2 text-center">
                                                    {routeMonthlyFees[`month${i + 1}`] ?? 0}
                                                </td>
                                            ))}
                                        </tr>
                                    )}


                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Feetable;